import {
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGIN_REQUEST,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE,
  USER_PROFILE_SUCCESS,
  USER_PROFILE_REQUEST,
  USER_PROFILE_FAILURE,
  CHANGE_PASSWORD_FAILURE,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
} from './constant';

export const loginSuccess = (payload) => ({ type: LOGIN_SUCCESS, payload });
export const loginFailure = (payload) => ({ type: LOGIN_FAILURE, payload });
export const loginRequest = (user) => ({ type: LOGIN_REQUEST, payload: user });

export const logoutRequest = () => ({ type: LOGOUT_REQUEST });
export const logoutSuccess = () => ({ type: LOGOUT_SUCCESS });
export const logoutFailure = (payload) => ({ type: LOGOUT_FAILURE, payload });

export const userProfileRequest = () => ({ type: USER_PROFILE_REQUEST });
export const userProfileSuccess = (payload) => ({ type: USER_PROFILE_SUCCESS, payload });
export const userProfileFailure = (payload) => ({ type: USER_PROFILE_FAILURE, payload });

export const changePasswordRequest = (newPassword) => ({ type: CHANGE_PASSWORD_REQUEST, payload: newPassword });
export const changePasswordSuccess = (payload) => ({ type: CHANGE_PASSWORD_SUCCESS, payload });
export const changePasswordFailure = (payload) => ({ type: CHANGE_PASSWORD_FAILURE, payload });

export const forgotPasswordRequest = (email, recaptcha = null) => ({
  type: FORGOT_PASSWORD_REQUEST,
  payload: { email, recaptcha },
});
export const forgotPasswordSuccess = (payload) => ({ type: FORGOT_PASSWORD_SUCCESS, payload });
export const forgotPasswordFailure = (payload) => ({ type: FORGOT_PASSWORD_FAILURE, payload });
